module.exports = __webpack_public_path__ + "static/media/mosque.cde1f8e6.png";